import React from "react";
import { useTranslation } from "react-i18next";

import { QuickOption } from "./types";
import {
    ConfirmOverlay,
    ConfirmModal,
    ConfirmTitle,
    ConfirmMessage,
    ConfirmActions,
    ConfirmCancelBtn,
    ConfirmDeleteBtn,
} from "./styled";
import { useDialogA11y } from "../shared/useDialogA11y";

type DeleteConfirmModalProps = {
    deleteOption: QuickOption;
    selectedLang: string;
    onCancel: () => void;
    onConfirm: () => void;
};

export function DeleteConfirmModal({
    deleteOption,
    selectedLang,
    onCancel,
    onConfirm,
}: DeleteConfirmModalProps): JSX.Element {
    const { t } = useTranslation();
    const { dialogRef, titleId } = useDialogA11y({ onCancel });

    return (
        <ConfirmOverlay
            data-testid="scan-to-server-call-delete-confirm-overlay"
            onClick={onCancel}
        >
            <ConfirmModal
                ref={dialogRef}
                role="dialog"
                aria-modal="true"
                aria-labelledby={titleId}
                data-testid="scan-to-server-call-delete-confirm-modal"
                onClick={(e) => e.stopPropagation()}
            >
                <ConfirmTitle id={titleId}>{t("Delete")}</ConfirmTitle>
                <ConfirmMessage>
                    {t("Are you sure you want to delete this option?")}
                    <br />
                    <strong>
                        {deleteOption.title[selectedLang] ||
                            deleteOption.title.fr ||
                            deleteOption.id}
                    </strong>
                </ConfirmMessage>
                <ConfirmActions>
                    <ConfirmCancelBtn
                        data-testid="scan-to-server-call-delete-cancel-btn"
                        onClick={onCancel}
                    >
                        {t("Cancel")}
                    </ConfirmCancelBtn>
                    <ConfirmDeleteBtn
                        data-testid="scan-to-server-call-delete-confirm-btn"
                        onClick={onConfirm}
                    >
                        {t("Delete")}
                    </ConfirmDeleteBtn>
                </ConfirmActions>
            </ConfirmModal>
        </ConfirmOverlay>
    );
}
